import { InsightCatalogue } from '../InsightCatalogue';
import {
  DataOnlyInsightPayload,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface ProjectsCategoryPayload extends DataOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_PROJECTS_CATEGORY;
    id: string;
    attributes: {
      data: Array<{
        category_id: string;
        category_name: string;
        project_status_group: string;
        project_count: number;
        category_total_count: number;
      }>;
    };
  };
}

export const parseProjectsCategoryPayload = (
  payload: BaseInsightPayload
): ProjectsCategoryPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_PROJECTS_CATEGORY,
    data.attributes,
    true,
    false
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      category_id: string;
      category_name: string;
      project_status_group: string;
      project_count: number;
      category_total_count: number;
    }>;
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_PROJECTS_CATEGORY,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
